import {
  panelOpened,
  panelClosed,
  removeExternalCollectionsClicked,
} from '@wix/bi-logger-platform-cm/v2'
import { connectExternalDbPanelAction } from '@wix/bi-logger-platform/v2'
import openErrorPanel from '@wix/wix-data-client-common/dist/esm/panels/error-panel/openErrorPanel'
import { getAssetUrlInWorker } from '@wix/wix-data-client-common/dist/esm/panels/getAssetUrl'
import { BI } from './external-db-driver-panel/constants'

const PANEL_NAME_FOR_BI = 'delete external collection'

interface RemovePanelProps {
  editorSdkProxy: any
  logger: any
  appApi: any
  wixDataConnectorSettingsClient: any
  i18n: any
  onError: () => void
  namespace: string
  experimentsManager: any
}

export default async ({
  editorSdkProxy,
  logger,
  appApi,
  wixDataConnectorSettingsClient,
  i18n,
  onError,
  namespace,
  experimentsManager,
}: RemovePanelProps) => {
  const t = i18n.t.bind(i18n)

  logger.bi(
    panelOpened({
      panel_name: PANEL_NAME_FOR_BI,
    }),
  )

  const isConnectExternalDBNewFlow = experimentsManager.enabled(
    'specs.wixDataClient.connectExternalDBNewFlow',
  )

  const illustration = isConnectExternalDBNewFlow
    ? await getAssetUrlInWorker(
        editorSdkProxy,
        'panel-icons/changeConnection.svg',
      )
    : await getAssetUrlInWorker(editorSdkProxy, 'panel-icons/generic_trash.svg')

  await openErrorPanel({
    editorSdkProxy,
    logger,
    headerText: t(
      isConnectExternalDBNewFlow
        ? 'WixCode_WarningModal_DisconnectExternalDatabase_Title'
        : 'Delete_External_Collection_Warning_Title',
    ),
    topDescriptionText: isConnectExternalDBNewFlow
      ? `
    <p> 
      ${t('WixCode_WarningModal_DisconnectExternalDatabase_Description')}
    </p>
    <br> 
    `
      : t('Delete_External_Collection_Warning_Paragraph'),
    bottomDescriptionText: t('Delete_External_Collection_Warning_Paragraph2'),
    illustration,
    mainActionText: t(
      isConnectExternalDBNewFlow
        ? 'WixCode_WarningModal_DisconnectExternalDatabase_PrimaryCTA'
        : 'Delete_External_Collection_Warning_Button_Delete',
    ),
    secondaryActionText: t(
      isConnectExternalDBNewFlow
        ? 'WixCode_WarningModal_DisconnectExternalDatabase_SecondaryCTA'
        : 'Delete_External_Collection_Warning_Button_Cancel',
    ),
    onMainActionClick: async () => {
      try {
        if (isConnectExternalDBNewFlow) {
          logger.bi(
            connectExternalDbPanelAction({
              action_type: BI.actions.click,
              button_name: BI.buttons.disconnect,
              input_name: BI.panels.disconnect,
            }),
          )
        } else {
          logger.bi(
            removeExternalCollectionsClicked({
              collections_namespace: namespace,
              endpoint_url: '',
            }),
          )
        }

        await wixDataConnectorSettingsClient.unregisterConnector(namespace)
        await appApi.onExternalDbDriverRemoved({ namespace })
        await appApi.refreshSchemasCache()
        await editorSdkProxy.document.application.livePreview.refresh({
          source: 'AFTER_EXTERNAL_DB_DELETION',
          shouldFetchData: true,
        })
      } catch {
        onError()
      }
    },
    onSecondaryActionClick: () => {
      if (isConnectExternalDBNewFlow) {
        logger.bi(
          connectExternalDbPanelAction({
            action_type: BI.actions.click,
            button_name: BI.buttons.cancel,
            input_name: BI.panels.disconnect,
          }),
        )
      } else {
        logger.bi(
          panelClosed({
            panel_name: PANEL_NAME_FOR_BI,
          }),
        )
      }
    },
    onCloseClick: () => {
      if (isConnectExternalDBNewFlow) {
        logger.bi(
          connectExternalDbPanelAction({
            action_type: BI.actions.click,
            button_name: BI.buttons.x,
            input_name: BI.panels.disconnect,
          }),
        )
      } else {
        logger.bi(
          panelClosed({
            panel_name: PANEL_NAME_FOR_BI,
          }),
        )
      }
    },
  })
}
